<template>
    <div class="general-modal">
        <BaseModal :padding="isMobileOrTablet ? MODAL_PADDING_MOBILE : MODAL_PADDING_DESKTOP"
                   maxWidth="500px"
                   maxHeight="500px"
                   useContentFullHeight
                   :isClosable="false">
            <template #header/>
            <template #content>
                <div class="general-modal__content general-modal__content--justify-center">
                    <AnimatedBits v-if="registrationRewardReceivedNotification?.data?.reward_amount?.amount"
                                  :amount="registrationRewardReceivedNotification?.data?.reward_amount?.amount"
                                  :currency="registrationRewardReceivedNotification?.data?.reward_amount?.currency"/>
                    <div class="general-modal__title">
                        {{ registrationRewardReceivedNotification?.data?.title }}
                    </div>
                    <div class="general-modal__subtitle">
                        {{ registrationRewardReceivedNotification?.data?.subtitle }}
                    </div>
                </div>
                <div class="general-modal__confetti">
                    <ConfettiExplosion v-bind="getConfettiProps" />
                </div>
            </template>
            <template #footer>
                <div class="general-modal__actions">
                    <span class="general-modal__action general-modal__action--confirm">
                        <BaseButton v-focus
                                    @click="emit('close')">
                            <Translate translationKey="quests-dashboard.collectMore"
                                       fallback="Collect More" /> 🔥
                        </BaseButton>
                    </span>
                </div>
            </template>
        </BaseModal>
    </div>
</template>

<script setup lang="ts">
    import ConfettiExplosion from 'vue-confetti-explosion';
    import {
        computed, ref, watch,
    } from 'vue';
    import BaseModal from '@/js/components/BaseModal.vue';
    import { ModalEnum, useModalStore } from '@/js/store/quests/game/modules/ModalStore';
    import { useModalActive } from '@/js/composables/useModalActive';
    import { useDeviceSize } from '@/js/composables/useDeviceSize';
    import BaseButton from '@/js/components/BaseButton.vue';
    import { useUserStore } from '@/js/store/quests/dashboard/UserStore';
    import { Notification } from '@/js/quests/dashboard/types/types';
    import { NotificationModalTypeEnum } from '@/js/quests/dashboard/types/enums';
    import AnimatedBits from '@/js/quests/dashboard/modals/notifications/AnimatedBits.vue';
    import { MODAL_PADDING_DESKTOP, MODAL_PADDING_MOBILE } from '@/js/quests/global/constants/modal';

    const emit = defineEmits<{(e: 'close'): void; }>();

    const modalStore = useModalStore();
    const userStore = useUserStore();
    const { isMobileOrTablet } = useDeviceSize();

    const notifications = ref<Notification[]>([]);
    const registrationRewardReceivedNotification = ref();

    const getConfettiProps = computed(() => ({
        duration: 2000,
    }) as unknown);

    useModalActive();

    watch(
        () => modalStore.modals[ModalEnum.REGISTER_BONUS],
        (newValue) => {
            if (newValue) {
                notifications.value = userStore?.notifications || [];
                const filteredNotifications = notifications.value.filter(
                    (notification) => notification.type === NotificationModalTypeEnum.RegistrationRewardReceived,
                );
                registrationRewardReceivedNotification.value = filteredNotifications.length > 0 ? filteredNotifications[0] : null;
            }
        },
        { immediate: true },
    );
</script>

<style scoped lang="scss">
@use "@/js/quests/dashboard/sass/mixins/_modal" as modalMixins;

.general-modal {
    @include modalMixins.modal;

    &__confetti {
        top: 50%;
    }
}
</style>
